import React, { lazy, Suspense, useEffect, useState } from "react";
import { useAppSelector } from "hooks/redux";
import createObject from "utils/createObject";
import reformatCPKeys from "utils/reformatCPKeys";
import omit from "lodash-es/omit";
import isEmpty from "lodash-es/isEmpty";
import pick from "lodash-es/pick";
import {
    BlockWrapper,
    CPSettingsBlockWrapper,
    CustomArrowExpand,
    CustomPlusCircled,
    SettingsBlockButtons,
    SettingsBlockHeader,
    SettingsBlockTitle,
} from "pages/settings/settingsPageStyles";
import CPSettingsBlock from "./CPSettingsBlock";
import Loader from "components/Loader/Loader";
import {
    getCPParams,
    saveCPSettingsItem,
    removeCPSettingsItem,
    SavedCPSettingsState,
} from "../../../store/reducers/SettingsSlice";
import { useDispatch } from "react-redux";
import error from "../../../utils/Notifications/Error";

const AddCPParamsModal = lazy(
    () => import("components/AddCPParamsModal/AddCPParamsModal")
);

const findExistedCPItems = (state: SavedCPSettingsState) => {
    const table_id = "cp-list";
    let saved_cp = [];
    for (let x = 0; x < 3; x++) {
        const state_table = state[`${table_id}-${x}`];
        if (Array.isArray(state_table) && state_table.length) {
            for (const item of state_table) {
                saved_cp.push(item.key);
            }
        }
    }
    return saved_cp;
};

const CPSettings = ({
    onArrowClick,
    isExpanded,
    changeCPColumnMask,
    CPColumnMask,
}: any) => {
    const [addCPParamsModalOpened, setAddCPParamsModalOpened] = useState(false);
    const {
        savedSettings,
        activeTicker,
        saved_CP_settings,
        MDPSelectedItem,
        activeGroup,
        memorized_settings,
    } = useAppSelector((state) => state.settings);
    // const { isBlocked } = useAppSelector(state => state.logs)
    const dispatch = useDispatch();
    const [CPData, setCPData] = useState([[], [], []]);
    const [CPIndex, setCPIndex] = useState(0);
    const [popupData, setPopupData] = useState({});
    useEffect(() => {
        dispatch(getCPParams());
    }, []);

    useEffect(() => {
        try {
            const keys = [] as Array<Array<string>>;
            const { CP } = savedSettings;
            // const { CP } = defaultSets
            const [cpKeys, cpValues] = CP;
            // console.log("const [cpKeys, cpValues] = CP", CP)
            const cpData = createObject(reformatCPKeys(cpKeys), cpValues);
            const omittedCP = omit(cpData, ["ID.depend"]);
            keys[0] = Object.keys(CPData[0]);
            keys[1] = Object.keys(CPData[1]);
            keys[2] = Object.keys(CPData[2]);
            let _popupdata = omit(omittedCP, keys.flat()) as {};
            const keys_in_state = findExistedCPItems(saved_CP_settings);

            for (const key of keys_in_state) {
                delete _popupdata[key];
            }

            setPopupData(_popupdata);
            if (!isEmpty(CPData[0])) {
                // setCPData(prev => _.pick(omittedCP, keys[0]))
                setCPData((prevState) => {
                    return CPData?.map((item, index) => {
                        if (index === 0) {
                            return pick(omittedCP, keys[0]);
                        } else return prevState[index];
                    }) as Array<[]>;
                });
            }
            if (!isEmpty(CPData[1])) {
                setCPData((prevState) => {
                    return CPData?.map((item, index) => {
                        if (index === 1) {
                            return pick(omittedCP, keys[1]);
                        } else return prevState[index];
                    }) as Array<[]>;
                });
            }
            if (!isEmpty(CPData[2])) {
                setCPData((prevState) => {
                    return CPData?.map((item, index) => {
                        if (index === 2) {
                            return pick(omittedCP, keys[2]);
                        } else return prevState[index];
                    }) as Array<[]>;
                });
            }
        } catch (e) {
            // console.error("in CP error")
        }
    }, [savedSettings?.CP, activeTicker?.name, activeGroup?.name]);

    const onChoose = (
        key: string,
        value: string | number,
        explicitCPIndex?: number
    ) => {
        const currentIdex = explicitCPIndex ?? CPIndex;
        changeCPColumnMask((prev) => {
            const newState = JSON.parse(JSON.stringify(prev));

            if (!newState[currentIdex].includes(key)) {
                newState[currentIdex].push(key);
                return newState;
            }
            return prev;
        });
        dispatch(
            saveCPSettingsItem({
                id: `cp-list-${currentIdex}`,
                key,
                value,
                affiliation: {
                    ticker_name: activeTicker?.name,
                    group_name: activeGroup?.name,
                    exchange_name: MDPSelectedItem?.SPname,
                },
                has_change: false,
            })
        );
        setPopupData((prev) => {
            const state = { ...prev };
            delete state[key];
            return state;
        });
    };

    const onRemove =
        (CPIndex: number) => (key: string, value: string | number) => {
            const defaultKeys = reformatCPKeys(savedSettings.CP[0]);

            dispatch(
                removeCPSettingsItem({
                    id: `cp-list-${CPIndex}`,
                    key,
                })
            );
            changeCPColumnMask((prev) => {
                const newState = JSON.parse(JSON.stringify(prev));

                const delIndex = newState[CPIndex].indexOf(key);
                if (~delIndex) {
                    newState[CPIndex].splice(delIndex, 1);
                    return newState;
                }
                return prev;
            });
            const key_value =
                savedSettings.CP[1][
                    savedSettings.CP[0].findIndex((x) => x === key)
                ];
            const popdata = Object.fromEntries(
                Object.entries({ [key]: key_value, ...popupData }).sort(
                    (a, b) =>
                        defaultKeys.indexOf(a[0]) - defaultKeys.indexOf(b[0])
                )
            );
            setPopupData(() => {
                return popdata;
            });
        };

    const handleCPParamsAddClick = (CPIndex: number) => () => {
        if (activeTicker.name !== "Название тикера") {
            setCPIndex(CPIndex);
            setAddCPParamsModalOpened((prev) => !prev);
        } else {
            error("Данные CP отсутствуют. Тикер не выбран");
        }
    };

    useEffect(() => {
        if (activeTicker.name !== "Название тикера") {
            let BUYIndexFlag, SELLIndexFlag, HEDGINGIndexFlag;
            memorized_settings.forEach((paramObj, index) => {
                if (paramObj.key === "BUY") {
                    BUYIndexFlag = index;
                }
                if (paramObj.key === "SELL") {
                    SELLIndexFlag = index;
                }
                if (paramObj.key === "HEDGING") {
                    HEDGINGIndexFlag = index;
                }
            });
            CPColumnMask.forEach((columnsKey: string[], column: number) => {
                columnsKey.forEach((key: string) => {
                    const rawKey = key.split(" ")[0];
                    const value =
                        memorized_settings.find((paramObj, index) => {
                            let indexFlag = 0;
                            if (key.includes("BUY")) {
                                indexFlag = BUYIndexFlag;
                            }
                            if (key.includes("SELL")) {
                                indexFlag = SELLIndexFlag;
                            }
                            if (key.includes("HEDGING")) {
                                indexFlag = HEDGINGIndexFlag;
                            }
                            return paramObj.key === rawKey && index > indexFlag;
                        })?.value || "";

                    onChoose(key, value, column);
                });
            });
        }
    }, [activeTicker.name, activeGroup.name, memorized_settings]);

    return (
        <>
            <CPSettingsBlockWrapper>
                <SettingsBlockHeader>
                    <SettingsBlockTitle>CP</SettingsBlockTitle>
                    <SettingsBlockButtons>
                        <CustomPlusCircled
                            onClick={handleCPParamsAddClick(0)}
                        />
                        {onArrowClick && (
                            <CustomArrowExpand onClick={onArrowClick} />
                        )}
                    </SettingsBlockButtons>
                </SettingsBlockHeader>
                <BlockWrapper>
                    <CPSettingsBlock
                        onRemove={onRemove(0)}
                        CPData={
                            Array.isArray(saved_CP_settings[`cp-list-0`])
                                ? saved_CP_settings[`cp-list-0`]
                                : []
                        }
                        id={`cp-list-0`}
                    />
                </BlockWrapper>
            </CPSettingsBlockWrapper>
            {isExpanded && (
                <CPSettingsBlockWrapper>
                    <SettingsBlockHeader>
                        <SettingsBlockTitle>CP</SettingsBlockTitle>
                        <SettingsBlockButtons>
                            <CustomPlusCircled
                                onClick={handleCPParamsAddClick(1)}
                            />
                        </SettingsBlockButtons>
                    </SettingsBlockHeader>
                    <BlockWrapper>
                        <CPSettingsBlock
                            onRemove={onRemove(1)}
                            CPData={
                                Array.isArray(saved_CP_settings[`cp-list-1`])
                                    ? saved_CP_settings[`cp-list-1`]
                                    : []
                            }
                            id={`cp-list-1`}
                        />
                    </BlockWrapper>
                </CPSettingsBlockWrapper>
            )}

            {isExpanded && (
                <CPSettingsBlockWrapper>
                    <SettingsBlockHeader>
                        <SettingsBlockTitle>CP</SettingsBlockTitle>
                        <SettingsBlockButtons>
                            <CustomPlusCircled
                                onClick={handleCPParamsAddClick(2)}
                            />
                        </SettingsBlockButtons>
                    </SettingsBlockHeader>
                    <BlockWrapper>
                        <CPSettingsBlock
                            onRemove={onRemove(2)}
                            CPData={
                                Array.isArray(saved_CP_settings[`cp-list-2`])
                                    ? saved_CP_settings[`cp-list-2`]
                                    : []
                            }
                            id={`cp-list-2`}
                        />
                    </BlockWrapper>
                </CPSettingsBlockWrapper>
            )}

            <Suspense fallback={<Loader size="large" />}>
                <AddCPParamsModal
                    isOpen={addCPParamsModalOpened}
                    onRequestClose={() => setAddCPParamsModalOpened(false)}
                    onChoose={onChoose}
                    data={popupData}
                />
            </Suspense>
        </>
    );
};

export default CPSettings;
